import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DialogModule, ButtonModule, SharedModule, InputTextModule, AutoCompleteModule, TooltipModule, ProgressSpinnerModule, DropdownModule, CalendarModule } from "primeng/primeng";
import { FormsModule } from "@angular/forms";
import { HttpModule } from "@angular/http";
import { InputTrimModule } from "../../../directives/input-trim/input-trim.module";
import { ReserveInvoiceDetailDialogComponent } from './reserve-invoice-detail-dialog.component';
import { CompanyService } from '../../../services/shared/company.service';

@NgModule({
    imports: [
        CommonModule,
        DialogModule,
        FormsModule,
        HttpModule,
        DropdownModule,
        ButtonModule,
        SharedModule,
        InputTextModule,
        AutoCompleteModule,
        TooltipModule,
        InputTrimModule,
        ProgressSpinnerModule,
        CalendarModule,
        TooltipModule
    ],

    declarations: [
        ReserveInvoiceDetailDialogComponent
    ],

    exports: [
        ReserveInvoiceDetailDialogComponent
    ],

    providers: [
        CompanyService
    ]
})

export class ReserveInvoiceDetailDialogModule { }
